import api from "@/services/api"
import { ref } from "vue"
import { useNotification } from "@/composables"

export const useMpesaPaymentRequest = () => {
    const { showError } = useNotification()

    const processing = ref(false)
    const setProcessing = (value) => {
        processing.value = value
    }

    const makeMpesaPaymentRequest = async (data) => {
        try {
            setProcessing(true)
            return await api.post(`/mpesa/request-payment`, data)
        } catch (error) {
            console.error(error)
            showError("Failed to make Mpesa payment request.")
        } finally {
            setProcessing(false)
        }
    }

    return {
        processing,
        makeMpesaPaymentRequest,
    }
}